import React from "react";
import {
  deleteLectureOverviewPermanently,
  deleteProgramWeekLectureOverviewPermanently,
  deleteWeekDayOverviewPermanently,
  deleteWeekOverviewPermanently,
  deleteWorkoutOverviewPermanently,
  remove_session,
  updateLectureOverview,
  updateProgramWeekLectureOverview,
  updateWeekDayOverview,
  updateWeekOverview,
} from "../functions/general";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ArrowDown from "../images/ArrowDown.svg";
import { updateWorkoutOverview } from "../functions/general";
import { usePermissions } from "../functions/usePermissions";
import DragHandler from "./DragHandler";

const VideoOverview = ({ item, fetchData, getLoggedInUser, type, index }) => {
  const { hasPermission } = usePermissions();

  const navigate = useNavigate();
  const [isOpen, setIsopen] = React.useState(index === 0 ? true : false);
  const [title, setTitle] = React.useState(item?.title);
  const [videoUrl, setVideoUrl] = React.useState(item?.url);
  const [errors, setErrors] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleUpdateOverviewVideo = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (validate()) {
      setLoading(true);
      if (type === "week") {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          week: item?.week,
        };
        updateWeekOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      } else if (type === "day") {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          weekDay: item?.weekDay,
        };
        updateWeekDayOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      } else if (type === "lecture") {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          lecture: item?.lecture,
        };
        updateLectureOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      } else if (type === "lecture") {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          lecture: item?.lecture,
        };
        updateLectureOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      } else if (type === "programWeekLecture") {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          lecture: item?.lecture,
        };
        updateProgramWeekLectureOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      } else {
        const videoData = {
          title: title,
          url: videoUrl,
          text: "",
          type: "video",
          fileSize: "",
          workout: item?.workout,
        };
        updateWorkoutOverview(videoData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update video.");
          }
          setLoading(false);
        });
      }
    }
  };

  const deleteHandler = (e, item) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete video overview permanently?") == true) {
      if (type === "week") {
        deleteWeekOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete video overview.");
          }
        });
      } else if (type === "workout") {
        deleteWorkoutOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete video overview.");
          }
        });
      } else if (type === "lecture") {
        deleteLectureOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete video overview.");
          }
        });
      } else if (type === "programWeekLecture") {
        deleteProgramWeekLectureOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete video overview.");
          }
        });
      } else {
        deleteWeekDayOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Video overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete video overview.");
          }
        });
      }
    }
  };
  const validate = () => {
    let errors = {
      title: "",
      videoUrl: "",
    };
    let isValid = true;
    // if (!title) {
    //   isValid = false;
    //   errors.title = "Please enter title.";
    // }
    if (!videoUrl) {
      isValid = false;
      errors.title = "Please enter URL.";
    }
    setErrors(errors);
    return isValid;
  };

  return (
    <div className="col-6 bg-white" style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", borderRadius: "10px", position: "relative" }}>
      <div
        className="py-4 text-black d-flex justify-content-between"
        style={{ fontSize: "18px", fontWeight: "500", cursor: "pointer" }}
        onClick={() => setIsopen(!isOpen)}
      >
        <span className="d-flex align-items-center" style={{ gap: "15px" }}>
          <DragHandler /> Video
        </span>
        <img src={ArrowDown} />
      </div>
      {isOpen && (
        <div>
          <form noValidate onSubmit={handleUpdateOverviewVideo}>
            <div className="form-group">
              <label>Video Title</label>
              <input type="text" className="form-control" placeholder="Enter video title" value={title} onChange={(e) => setTitle(e.target.value)} />
              {/* {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>} */}
            </div>
            <div className="form-group">
              <label>Video URL</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter video URL"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
              {errors.videoUrl && !videoUrl && <div className="text-warning font-size-12 mt-2">{errors.videoUrl}</div>}
            </div>
            <div className="modal-footer border-0 px-0">
              {((hasPermission("edit-day-overview") && type === "day") ||
                (hasPermission("edit-workout-overview") && type === "workout") ||
                (hasPermission("edit-lecture-overview") && type === "lecture") ||
                (hasPermission("edit-program-week-lecture-overview") && type === "programWeekLecture") ||
                (hasPermission("edit-week-overview") && type === "week")) && (
                <button type="submit" className="btn btn-primary btn-sm">
                  {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Update
                </button>
              )}
              {((hasPermission("delete-day-overview") && type === "day") ||
                (hasPermission("delete-workout-overview") && type === "workout") ||
                (hasPermission("delete-lecture-overview") && type === "lecture") ||
                (hasPermission("delete-program-week-lecture-overview") && type === "programWeekLecture") ||
                (hasPermission("delete-week-overview") && type === "week")) && (
                <button onClick={(e) => deleteHandler(e, item)} className="btn btn-danger btn-sm">
                  Delete
                </button>
              )}
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default VideoOverview;
